export const CONFIRMATION_TYPES = {
  EMAIL: "email",
  TRADE_IN: "trade-in"
};
